export const ESTADOS_DIAGNOSTICO = {
  completado: { label: 'Completado', color: '#10B981', bgColor: '#D1FAE5' },
  en_progreso: { label: 'En progreso', color: '#3B82F6', bgColor: '#DBEAFE' },
  en_revision: { label: 'En revisión', color: '#F59E0B', bgColor: '#FEF3C7' },
  pendiente:   { label: 'Pendiente',   color: '#6B7280', bgColor: '#F3F4F6' },
};

export const ROLES = {
  ADMIN:   'admin',
  CLIENTE: 'cliente',
};
